import { useMsal } from "@azure/msal-react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Checkbox, FormControlLabel, List, ListItem, Modal, Popover, TextField } from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserLauchMailresponse } from "../Redux/Approver";
import "./CommunicationsTable.css";
import MyContentMailGeneration from "./MyContentMailGeneration";
import ApprovedTemplate from "../E-CertificateComponent/ApprovedTemplate";
const CustomFooter = () => <div></div>;
const CommunicationsTable = ({
  setL2
}) => {
  const [openDate, setOpenDate] = useState(false);
  const [anchorElDate, setAnchorElDate] = useState(null);
  const [statusName, setStatusName] = useState("All");
  const [searchedText, setSearchedText] = useState("");
  const [selectedMail, setSelectedMail] = useState("");
  const [initialRows, setInitialRows] = useState([]);
  const [uniqueID, setUniqueID] = useState("");
  const [rows, setRows] = useState(initialRows);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentColumn, setCurrentColumn] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(5);
  const [openModal, setOpenModal] = useState(false);
  const [modalRecord, setModalRecord] = useState();
  const [status, setStatus] = useState();
  const [userQuery, setUserQuery] = useState("");
  const [activeScreen, setActiveScreen] = useState("default");
  const {
    instance
  } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [user, setUser] = useState(null);
  const [startDate, setDate] = React.useState(new Date());
  const [createdDate, setCreatedDate] = useState("");
  const [program, setProgram] = useState("");
  const [type, setType] = useState("");
  const [rangeStart, setRangeStart] = React.useState(new Date());
  const defaultEndDate = new Date();
  defaultEndDate.setDate(defaultEndDate.getDate() + 7);
  const [sendArrDate, setSendArrDate] = useState(false);
  const [rangeEnd, setRangeEnd] = React.useState(defaultEndDate);
  const [sortModel, setSortModel] = useState([]);
  const [sortModelNew, setSortModelNew] = useState([]);
  const [activeButton, setActiveButton] = useState(1);
  const [secureCertificateUrl, setSecureCertificateUrl] = useState("");
  const launchMails = useSelector(state => state.approver.userLaunchMails);
  const [campaignId, setaCmpaignId] = useState();
  const dateSortComparatornew = (v1, v2) => {
    const date1 = moment(v1, "DD-MM-YYYY").toDate(); // Parse the date string to Date object
    const date2 = moment(v2, "DD-MM-YYYY").toDate(); // Parse the date string to Date object
    return date1 - date2; // Compare timestamps
  };
  const selectDateHandler = d => {
    setDate(d);
    let created_date = moment(d).format("DD-MM-YYYY");
    setCreatedDate(created_date);
    setCurrentColumn("sendDate");
  };
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();
  useEffect(() => {
    if (activeAccount) {
      setUser(activeAccount.idTokenClaims.enterpriseID);
    }
  }, [activeAccount]);
  useEffect(() => {
    if (currentColumn == "sendDate") {
      handleSelection(createdDate, false);
    }
  }, [currentColumn, startDate]);
  let approverStatus = {
    NotApplicable: 0,
    "Waiting for Approval": -1,
    Approved: 1,
    "On hold": 2
  };
  const selectStartDate = d => {
    setRangeStart(d);
  };
  const selectEndDate = d => {
    setRangeEnd(d);
  };
  const handleFilterClick = (event, column) => {
    setCurrentColumn(column);
    setAnchorEl(event.currentTarget);
  };
  const handleFilterClose = () => {
    setAnchorEl(null);
    setCurrentColumn(null);
    setSearchTerm("");
  };
  const handleSelection = (value, bool) => {
    const columnFilters = selectedFilters[currentColumn] || [];
    const currentIndex = columnFilters.indexOf(value);
    let newSelectedFilters = {
      ...selectedFilters
    };
    if (!Array.isArray(value)) {
      if (currentIndex === -1) {
        currentColumn !== null && (currentColumn == "sendDate" ? newSelectedFilters[currentColumn] = value : newSelectedFilters[currentColumn] = [...columnFilters, value]);
      } else {
        currentColumn !== null && (newSelectedFilters[currentColumn] = columnFilters.filter(item => item !== value));
      }
    } else {
      newSelectedFilters[currentColumn] = [...value];
      setAnchorEl(null);
    }
    setSelectedFilters(newSelectedFilters);
    let filteredRows = launchMails;
    Object.keys(newSelectedFilters).forEach(column => {
      if (newSelectedFilters[column]?.length > 0) {
        filteredRows = filteredRows.filter(row => newSelectedFilters[column].includes(row[column]));
      }
    });
    setRows(filteredRows?.filter(value => {
      return value;
    }).sort((a, b) => {
      //  if (a["sendDate"] < b["sendDate"]) return 1;
      //  if (a["sendDate"] > b["sendDate"]) return -1;
      //  return 0;
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    }));
  };
  const handleReset = () => {
    setSelectedFilters({});
    setRows(launchMails.filter(value => {
      return value;
    }).sort((a, b) => {
      //  if (a["sendDate"] < b["sendDate"]) return 1;
      //  if (a["sendDate"] > b["sendDate"]) return -1;
      //  return 0;
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    }));
    handleFilterClose();
  };
  const handleSort = field => {
    setSortModel(prevSortModel => {
      const existingModel = prevSortModel.find(model => model.field === field);
      const sortDirection = existingModel ? existingModel.sort === "asc" ? "desc" : "asc" : "asc";
      return [{
        field,
        sort: sortDirection
      }];
    });
  };
  const handleOpen = record => {
    setOpenModal(true);
    setModalRecord(record);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleDispalyContent = (value, uniqueID, status, program, type, campaignId, subcategory, secureFileCertificateUrl) => {
    setSelectedMail(value);
    setUniqueID(uniqueID);
    setStatus(status);
    subcategory === "Endorsements" && type === "E-Certificate" && secureFileCertificateUrl.split("===")[0] === 'pre-approved' ? setActiveScreen("certificate") : setActiveScreen("contentscreen");
    setSecureCertificateUrl(secureFileCertificateUrl);
    setProgram(program);
    setType(type);
    setaCmpaignId(campaignId);
  };
  const columns = [{
    field: "id",
    headerName: <div className="migrated-style-communicationstable-3b8426-1">SI#</div>,
    minWidth: 70,
    sortable: false,
    flex: 1,
    renderCell: params => params.api.getSortedRowIds().indexOf(params.id) + 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "subcategory",
    headerName: <div className="migrated-style-communicationstable-3b8426-2">
     Content
     <div>
      <FilterAltIcon onClick={e => handleFilterClick(e, "subcategory")} className="migrated-style-communicationstable-3b8426-3" />
     </div>
    </div>,
    minWidth: 130,
    sortable: true,
    flex: 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "mailtype",
    headerName: <div className="migrated-style-communicationstable-3b8426-4">
     Sub-Type
     <FilterAltIcon onClick={e => handleFilterClick(e, "mailtype")} className="migrated-style-communicationstable-3b8426-5" />
    </div>,
    minWidth: 140,
    sortable: true,
    flex: 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "programname",
    headerName: <div className="migrated-style-communicationstable-3b8426-6">
     Program Name
     <SearchIcon onClick={e => handleFilterClick(e, "programname")} className="migrated-style-communicationstable-3b8426-7" />
    </div>,
    //  renderHeader: (params) => (
    //   <CustomHeader
    //    colDef={params.colDef}
    //    onSortClick={handleSort}
    //    sortDirection={
    //     sortModel.find((model) => model.field === "programname")?.sort || null
    //    }
    //   />
    //  ),
    minWidth: 180,
    sortable: true,
    flex: 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "contentlink",
    headerName: <div className="migrated-style-communicationstable-3b8426-8">
     View Content
    </div>,
    minWidth: 130,
    sortable: false,
    flex: 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell",
    // Center-align cell values
    renderCell: params => <p onClick={() => {
      handleDispalyContent(params.row.template, params.row.uniqueID, params.row.isApproved, params.row.programname, params.row.mailtype, params.row.campaignId, params.row.subcategory, params.row.secureCertificateUrl);
      setL2(params.row.programname); //tentative
    }} className="migrated-style-communicationstable-3b8426-9">
     View Content
    </p>
  }, {
    field: "senddatetime",
    headerName: <div className="migrated-style-communicationstable-3b8426-10">
     Date & Time Created
     <CalendarMonthIcon onClick={e => {
        setOpenDate(true);
        setAnchorElDate(e.currentTarget);
      }} className="migrated-style-communicationstable-3b8426-11" />
    </div>,
    //  renderHeader: (params) => (
    //   <CustomDateHeader
    //    colDef={params.colDef}
    //    sortModel={sortModel}
    //    onSortModelChange={(newModel) => setSortModel(newModel)}
    //   />
    //  ),
    minWidth: 210,
    sortable: true,
    sortComparator: dateSortComparatornew,
    flex: 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell" // Center-align cell values
  }, {
    field: "isApproved",
    headerName: <div className="migrated-style-communicationstable-3b8426-12">
     Status
     <div>
      <FilterAltIcon onClick={e => handleFilterClick(e, "isApproved")} className="migrated-style-communicationstable-3b8426-13" />
     </div>
    </div>,
    minWidth: 150,
    sortable: false,
    flex: 1,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell",
    // Center-align cell values
    renderCell: params => <p>
     {params.row.isApproved == 1 ? "Approved" : params.row.isApproved == 0 ? "Not Applicable" : params.row.isApproved == 2 ? "On Hold" : params.row.isApproved == -1 ? "Waiting for Approval" : "All"}
    </p>
  }, {
    field: "details",
    headerName: <div className="migrated-style-communicationstable-3b8426-14">
     Details
    </div>,
    minWidth: 100,
    sortable: false,
    flex: 0.3,
    headerClassName: "left-align-header",
    // Center-align header
    cellClassName: "left-cell",
    // Center-align cell values
    renderCell: params => <img onClick={() => handleOpen(params.row)} src={process.env.PUBLIC_URL + "/Images/desc_icon.png"} className="migrated-style-communicationstable-3b8426-15"></img>
  }];
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Filtered list based on search term

  const filteredOptions = currentColumn == "isApproved" ? Array.from(new Set(launchMails?.map(row => row[currentColumn]))) : Array.from(new Set(launchMails?.map(row => row[currentColumn]))).filter(value => value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()));
  useEffect(() => {
    dispatch(fetchUserLauchMailresponse(user));
  }, [user]);
  const handleCategoryChange = e => {
    setStatusName(e.target.value);
    if (searchedText == "" && Object.keys(selectedFilters).length == 0) {
      if (e.target.value == "Approved") {
        setRows(launchMails?.filter(value => {
          return value?.isApproved == 1;
        }).map((item, sno) => ({
          ...item,
          id: sno + 1
        })));
      } else if (e.target.value == "Not Applicable") {
        setRows(launchMails?.filter(value => {
          return value?.isApproved == 0;
        }).map((item, sno) => ({
          ...item,
          id: sno + 1
        })));
      } else if (e.target.value == "On Hold") {
        setRows(launchMails?.filter(value => {
          return value?.isApproved == 2;
        }).map((item, sno) => ({
          ...item,
          id: sno + 1
        })));
      } else if (e.target.value == "Waiting for Approval") {
        setRows(launchMails?.filter(value => {
          return value?.isApproved == -1;
        }).map((item, sno) => ({
          ...item,
          id: sno + 1
        })));
      } else {
        setRows(launchMails.map((item, sno) => ({
          ...item,
          id: sno + 1
        })));
      }
    } else {
      //   setCurrentColumn("isApproved");
      let val = e.target.value == "Approved" ? 1 : e.target.value == "Waiting for Approval" ? -1 : e.target.value == "Not Applicable" ? 0 : e.target.value == "All" && 2;
      handleSelection(val, true);
    }
  };
  const clearFilters = () => {
    setSelectedFilters({});
    setSortModel([]);
    // setRows(launchMails?.map((item, sno) => ({ ...item, id: sno + 1 })));
    setRows(launchMails?.filter(value => {
      return value;
    }).sort((a, b) => {
      //  if (a["sendDate"] < b["sendDate"]) return 1;
      //  if (a["sendDate"] > b["sendDate"]) return -1;
      //  return 0;
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    })
    // .map((item, sno) => ({ ...item, id: sno + 1 }))
    );
  };
  const handleSearchChange = e => {
    setSearchedText(e.target.value);
  };
  useEffect(() => {
    setSelectedFilters({});
    setStatusName("All");
    setRows(launchMails?.filter(value => {
      return value?.category?.toLowerCase()?.includes(searchedText.toLowerCase()) || value?.mailtype?.toLowerCase()?.includes(searchedText.toLowerCase()) || value?.programname?.toLowerCase()?.includes(searchedText.toLowerCase()) || value?.user?.toLowerCase()?.includes(searchedText.toLowerCase());
    })?.map((item, sno) => ({
      ...item,
      id: sno + 1
    })).sort((a, b) => {
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    }));
  }, [searchedText]);
  useEffect(() => {
    setRows(launchMails?.filter(value => {
      return value;
    }).sort((a, b) => {
      //  if (a["sendDate"] < b["sendDate"]) return 1;
      //  if (a["sendDate"] > b["sendDate"]) return -1;
      //  return 0;
      const dateA = moment(a.sendDate, "DD/MM/YYYY").toDate();
      const dateB = moment(b.sendDate, "DD/MM/YYYY").toDate();
      return dateB - dateA;
    })
    // .map((item, sno) => ({ ...item, id: sno + 1 }))
    );
  }, [launchMails]);
  const rowsWithSerial = rows.map((row, index) => ({
    ...row,
    id: index + 1
  }));
  const handleSortModelChange = newSortModel => {
    setSortModelNew(newSortModel);
  };
  return <>
   {activeScreen == "default" && <>
     <div className="btns-container">
      {/* <Button onClick={clearFilters}> */}
      <span className="clear-filter" onClick={clearFilters}>
       Clear Filter
      </span>
     </div>
     <div className="datagrid-content-container migrated-style-communicationstable-3b8426-16">
      <DataGrid
        // rows={rows}
        rows={rowsWithSerial} columns={columns} apiRef={apiRef}
        // sortModel={sortModel}
        // onSortModelChange={(newModel) => setSortModel(newModel)}
        sortModel={sortModelNew} onSortModelChange={handleSortModelChange} sortingOrder={["asc", "desc"]}
        // pageSize={pageSize}
        initialState={{
          pagination: {
            paginationModel: {
              page: 0,
              pageSize: 7
            }
          }
        }}
        //   pageSizeOptions={[5, 10]}
        //  sortModel={initialSortModel}
        rowsPerPageOptions={[]}
        //   autoHeight={true}
        // disableColumnMenu // This removes the three dots menu
        sx={{
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#022278",
            // Customize the header background color
            color: "white" // Customize text color
          },
          "& .MuiDataGrid-root": {
            width: "100%" // Ensure DataGrid spans the full width
          },
          "& .MuiDataGrid-sortIcon": {
            color: "#fff" // Customize the sorter (sort icon) color
          },
          "& .MuiDataGrid-columnHeader": {
            position: "sticky",
            top: 0,
            backgroundColor: "#022278",
            // Optional: to ensure it’s visible on scroll
            color: "#fff"
          },
          "& .MuiDataGrid-columnHeaders": {
            width: "var(--DataGrid-rowWidth)"
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "white",
            width: "calc(100% - 2px)"
          },
          "& ..MuiDataGrid-topContainer": {
            width: "700px !important"
          }
        }} components={{
          Footer: CustomFooter // Replace default footer with your custom component
        }} />
      <Modal hideBackdrop open={openModal} onClose={handleClose} aria-labelledby="child-modal-title" closeAfterTransition aria-describedby="child-modal-description" className="modal-container">
       <Box className="model">
        <div className="model_heading">
         <h5 className="paramodel">Details</h5>
         <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
          Close
         </span>
        </div>
        <hr />
        <div className="program-modal-details">
         <div className="program-details-wrap">
          <p className="program-details-header">Category: </p>
          <p className="program-details-value">{modalRecord?.category}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Type: </p>
          <p className="program-details-value">{modalRecord?.subcategory}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Program Name: </p>
          <p className="program-details-value">{modalRecord?.programname}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Sub-Type: </p>
          <p className="program-details-value">{modalRecord?.mailtype}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Date & Time Created: </p>
          <p className="program-details-value">{modalRecord?.senddatetime}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">On Behalf of: </p>
          <p className="program-details-value migrated-style-communicationstable-3b8426-17">{modalRecord?.onBehalf}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Status: </p>
          <p className="program-details-value">
           {modalRecord?.isApproved == 1 ? "Approved" : modalRecord?.isApproved == 0 ? "Not Applicable" : modalRecord?.isApproved == 2 ? "On Hold" : "Waiting for Approval"}
          </p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Additional Notes: </p>
          <p className="program-details-value"></p>
         </div>
        </div>
       </Box>
      </Modal>

      <Popover open={openDate} onClose={() => setOpenDate(false)} anchorEl={anchorElDate} anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }} className="pop-date">
       <div className="date-container">
        <DatePicker open={openDate} dateFormat="yyyy/MM/dd" selected={startDate} onChange={e => {
              selectDateHandler(e);
              setOpenDate(false);
            }}
            // minDate={today}
            todayButton={"Today"} />
       </div>
      </Popover>

      <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleFilterClose} anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }} PaperProps={{
          style: {
            maxHeight: 300,
            // Set your desired height here
            maxWidth: 250,
            overflow: "auto",
            paddingLeft: 10,
            paddingRight: 10
          }
        }}>
       {currentColumn !== "isApproved" && <TextField variant="outlined" margin="dense" fullWidth placeholder={`Search`} value={searchTerm} sx={{
            "& .MuiInputBase-input": {
              fontSize: "0.7rem",
              // Change the font size as needed
              padding: "3.5px 6px"
            }
          }} onChange={e => setSearchTerm(e.target.value)} />}
       <List dense>
        {filteredOptions.map((value, index) => <ListItem key={index} sx={{
              padding: "0px",
              // Adjust padding as needed
              height: "22px"
            }}>
          <FormControlLabel control={<Checkbox checked={selectedFilters[currentColumn]?.includes(value)} onChange={() => handleSelection(value, false)} sx={{
                "& .MuiSvgIcon-root": {
                  //   fontSize: 12, // Change this to your desired size
                  width: "0.6em",
                  height: "0.6em"
                }
              }} />} label={value == 1 ? "Approved" : value == 0 ? "Not Applicable" : value == 2 ? "On Hold" : value == -1 ? "Waiting for Approval" : value} sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "0.8rem",
                  // Change the font size as needed
                  padding: "0px" // Adjust padding as needed
                }
              }} />
         </ListItem>)}
       </List>
       <Button sx={{
            fontSize: "0.7em",
            minWidth: "0px",
            paddingLeft: "0px"
          }} onClick={handleReset}>
        Reset
       </Button>
      </Popover>
     </div>
    </>}
   {activeScreen != "default" && activeScreen !== "certificate" && <MyContentMailGeneration setL2={setL2} selectedMail={selectedMail} setSelectedMail={setSelectedMail} uniqueID={uniqueID} setActiveScreen={setActiveScreen} status={status} program={program} type={type} campaignId={campaignId} />}
   {activeScreen === "certificate" && <ApprovedTemplate outputFileName={secureCertificateUrl} backButton={'enabled'} setActiveScreen={setActiveScreen} setL2={setL2} />}
  </>;
};
export default CommunicationsTable;
